export default {
	labelCol: { xs: { span: 24 }, sm: { span: 6 } },
	wrapperCol: { xs: { span: 24 }, sm: { span: 18 } },
	marginBottom: '8pt'
};


// WEBPACK FOOTER //
// ./portal-components/Portal/formItemLayout.js